<template>
  <el-menu-item v-if="!item.hidden" :index="`${sysPath}/` + `${URL}/` + basePath">
    <i :class="item.meta.icon"></i>
    {{ item.meta.title }}
  </el-menu-item>
</template>

<script>
export default {
  name: "siderbarItem",
  props: {
    // route object
    item: {
      type: Object,
      required: true,
    },
    basePath: {
      type: String,
      default: "",
    },
  },
  data() {
    return {};
  },

  computed: {
    URL() {
      return this.$route.path.split("/")[2];
    },
    sysPath() {
      const sysRoute = this.$router.options.routes.find((e) => e.name === "sys");
      return sysRoute ? sysRoute.path : "/sys";
    },
  },
};
</script>

<style lang="scss" scoped>
.el-menu-item {
  height: vw(45);
  margin: vw(15) vw(20);
  line-height: vw(45);
  border-radius: vw(5);
  font-weight: bold;
  font-size: vw(18);

  i {
    margin-right: vw(12);
    color: black;
    font-weight: bold;
    font-size: vw(22);
  }
}
</style>
